 /**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){ 
      $('.slider').slick({
        dots: false,
        arrow: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000
        ,prevArrow: '<button class="flickity-prev-next-button previous" type="button" aria-label="previous"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>'
        ,nextArrow: '<button class="flickity-prev-next-button next" type="button" aria-label="next"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>'
   
        ,responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
          ]
    });

$('.order_slider').slick({
        dots: false,
        arrow: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000
        ,prevArrow: '<button class="flickity-prev-next-button previous" type="button" aria-label="previous"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>'
        ,nextArrow: '<button class="flickity-prev-next-button next" type="button" aria-label="next"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>'
   
        ,responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
          ]
    });

  /* shop the look  start */
  
  if ($(window).width() > 1008) {
 var $carousel =  $('.ShopTheLook__Inner .ShopTheLook__ProductList').flickity();
 $carousel.flickity('destroy').addClass('itg_shop_loop'); 
  
  $('.ShopTheLook__Dot').click(function(){
    var get = $(this).attr('data-product-index');
    //alert(get);
   $('.ShopTheLook__ProductItem').each(function(){
    var set = $(this).attr('data-product-index');
     //alert(set);
     if(get == set){
       $(this).addClass('is-active').siblings().removeClass('is-active');
       //alert(set);
     } else {
       $(this).addClass('click');
     }
     });
     });
  }

 /* shop the look end */

 $('.ctm_slider').slick({
        dots: false,
        arrow: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        adaptiveHeight: true,
        prevArrow: '<button class="flickity-prev-next-button previous" type="button" aria-label="previous"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>'
        ,nextArrow: '<button class="flickity-prev-next-button next" type="button" aria-label="next"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>'
  
    });


$('.itg_slide').click(function(){
var sub_title = $(this).attr('data-get');
  //alert(sub_title);
$('.get:not(.slick-cloned)').each(function() {
var tool =  $(this).attr('data-slide');
  //alert(tool);
  if(sub_title == tool ){
  var num = $(this).attr('data-slick-index');  
    //alert(num);
  $('.ctm_slider').slick('slickGoTo', num);
  }
});
 }); 
  
});

/* video sound js */
// $(document).ready(function(){ 
//   $('.ctm_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
//     $(this).find('video').each(function() {
//       $(this).prop('muted', true);
//     });
//   //  $('.get.slick-slide.slick-current.slick-active').find('video').prop('muted', false);
//     //$('.get.slick-slide.slick-current.slick-active').find('video')[0].play();
//     $('.get.slick-slide.slick-current.slick-active').find('.unmuteVideo').hide();
//     $('.get.slick-slide.slick-current.slick-active').find('.muteVideo').show();   
// });

//   $(document).on('click','.veidio_mute_icon', function() {
//     if($(this).siblings('video').prop('muted')) {
//       $(this).siblings('video').prop('muted', false);
//       //    $(this).parent('.mp4_video').find('video').addClass('5a45a4s5a45s4a');
//      // $('.get.slick-slide.slick-current.slick-active').find('video')[0].play();
//           $(this).find('.unmuteVideo').show();
//           $(this).find('.muteVideo').hide();
//     } else {
//       $(this).siblings('video').prop('muted', true);
//         $(this).find('.unmuteVideo').hide();
//         $(this).find('.muteVideo').show();
//     }
// });   

// });


/**
$(window).on('load', function () {
  setTimeout(function () {
$('#insta-feed').slick({
        dots: false,
        arrow: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000
        ,prevArrow: '<button class="flickity-prev-next-button previous" type="button" aria-label="previous"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>'
        ,nextArrow: '<button class="flickity-prev-next-button next" type="button" aria-label="next"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>'
   
        ,responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
          ]
   
 });
   }, 2000);
 });
**/